var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoSubir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.166,
    height: 22.998,
    viewBox: "0 0 19.166 22.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69569",
    "data-name": "Trazado 69569",
    d: "M1398.611,672.8l-3.34-3.34a6.664,6.664,0,0,0-4.743-1.964H1386.2a4.8,4.8,0,0,0-4.792,4.79v13.416a4.8,4.8,0,0,0,4.792,4.792h9.583a4.8,4.8,0,0,0,4.792-4.792v-8.16a6.666,6.666,0,0,0-1.965-4.744Zm-1.355,1.355a4.829,4.829,0,0,1,.772,1.006h-4.16a.96.96,0,0,1-.958-.958v-4.16a4.8,4.8,0,0,1,1.006.771l3.34,3.34Zm1.4,11.547a2.878,2.878,0,0,1-2.875,2.875H1386.2a2.878,2.878,0,0,1-2.875-2.875V672.29a2.879,2.879,0,0,1,2.875-2.875h4.327c.156,0,.311.008.465.022v4.77a2.879,2.879,0,0,0,2.875,2.875h4.77c.014.153.022.309.022.465v8.16Zm-4.114-4.33a.958.958,0,1,1-1.355,1.355l-1.239-1.239v4.215a.958.958,0,1,1-1.916,0v-4.215l-1.239,1.239a.958.958,0,0,1-1.355-1.355l1.547-1.547a2.841,2.841,0,0,1,4.012,0l1.547,1.547Z",
    transform: "translate(-1381.409 -667.5)",
    fill: "#003763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoSubir);
export default __webpack_public_path__ + "static/media/Icono-Subir.3491ffaa693049bed2a17321dec77b42.svg";
export { ForwardRef as ReactComponent };